import React, { useContext } from 'react'
import { useLocation } from 'react-router-dom'
import classNames from 'classnames'
import { UiContext } from 'context/ui'

import LogoImg from 'i/icons/talkpro_logo_white.svg'
import styles from './DashboardHeader.module.scss'
import { ReactComponent as HamburgerIcon } from 'i/icons/hamburger_3_white.svg'
import { ReactComponent as AddIcon } from 'i/icons/add_white.svg'
import { POPUPS_ID } from 'utils/constants'
import { DashboardMobileMenu } from 'components/Dashboard/DashboardMobileMenu'

const DashboardHeader = ({ handleClick, activeIndex, mobileTabsHandler, calendarCount }) => {
  const location = useLocation()
  const isProDashboard = location.pathname === '/dashboard/pro'
  const { setActivePopupId } = useContext(UiContext)

  const openInvite = () => {
    setActivePopupId(POPUPS_ID.sendInvite)
  }

  return (
    <div
      className={classNames(styles.header, {
        [styles.headerV2]: isProDashboard,
      })}
    >
      <a className={styles.logo} href="https://join.talkpro.com">
        <img src={LogoImg} className={styles.logoImage} alt="Logo" />
      </a>

      {isProDashboard && (
        <div className={styles.centerTabs}>
          <DashboardMobileMenu
            mobileTabsHandler={mobileTabsHandler}
            activeIndex={activeIndex}
            calendarCount={calendarCount}
            inline
          />
        </div>
      )}

      <div className={styles.actions}>
        {isProDashboard && (
          <button className={styles.addButton} type="button" onClick={openInvite}>
            <AddIcon className="icon size_mod" />
          </button>
        )}
        <button className={styles.hamburger} type="button" onClick={handleClick}>
          <HamburgerIcon className="icon size_mod" />
        </button>
      </div>
    </div>
  )
}

export default DashboardHeader
